/**
 * Helper para formatear con seguridad cualquier valor de propiedad
 * previniendo errores de renderizado de objetos en React (como Timestamps de Firestore {_seconds, _nanoseconds}).
 */

export function formatSafePropertyText(value: any, fallback = '--'): string {
  if (value === null || value === undefined || value === '') {
    return fallback;
  }

  // Si ya es un string o un número simple
  if (typeof value === 'string' || typeof value === 'number') {
    const str = String(value).trim();
    return str.length > 0 ? str : fallback;
  }

  if (typeof value === 'boolean') {
    return value ? 'Sí' : 'No';
  }

  // Objeto Timestamp de Firestore con método toDate()
  if (typeof value.toDate === 'function') {
    try {
      const d: Date = value.toDate();
      if (!isNaN(d.getTime())) {
        return d.toLocaleDateString('es-CO', { year: 'numeric', month: 'short', day: 'numeric' });
      }
    } catch {
      // Ignorar fallo y continuar fallback
    }
  }

  // Objeto de Firestore con _seconds o seconds
  if (typeof value === 'object') {
    const seconds = value._seconds ?? value.seconds;
    if (typeof seconds === 'number') {
      try {
        const d = new Date(seconds * 1000);
        if (!isNaN(d.getTime())) {
          return d.toLocaleDateString('es-CO', { year: 'numeric', month: 'short', day: 'numeric' });
        }
      } catch {
        // Ignorar fallo
      }
    }

    // Instancia nativa de Date
    if (value instanceof Date && !isNaN(value.getTime())) {
      return value.toLocaleDateString('es-CO', { year: 'numeric', month: 'short', day: 'numeric' });
    }

    // Si tiene campos comunes como nombre, label, valor, etc.
    if (value.nombre || value.name || value.label || value.descripcion || value.value) {
      return String(value.nombre || value.name || value.label || value.descripcion || value.value);
    }

    // Si es un arreglo
    if (Array.isArray(value)) {
      const items = value.map((it) => formatSafePropertyText(it, '')).filter(Boolean);
      return items.length > 0 ? items.join(', ') : fallback;
    }
  }

  return fallback;
}
